export default "__VITE_ASSET__DrOGyHDN__"